import type {
  BusinessGetResponseType,
  UserCreateResponseType,
} from "@sellar-io/api-v2/types";

export type AuthenticatedAccessMode =
  | "operational"
  | "supplier-onboarding"
  | "supplier-onboarding-denied";

export const resolveAuthenticatedAccessMode = ({
  business,
  sellarUser,
}: {
  business: BusinessGetResponseType | null;
  sellarUser: UserCreateResponseType | null;
}): AuthenticatedAccessMode => {
  if (sellarUser?.type === "admin") {
    return "operational";
  }

  if (business?.Supplier?.onboardingCompletedAt !== null) {
    return "operational";
  }

  return business.BusinessUser?.role === "owner"
    ? "supplier-onboarding"
    : "supplier-onboarding-denied";
};
